import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import {ADDRESS_PATTERN} from '../../constants/app.constants';

export const MAP_ADDRESS_REGEX = ADDRESS_PATTERN;

function collapseWhitespace(value: string): string {
  return value.replace(/\s+/g, ' ').trim();
}

export function normalizeMapAddressInput(value?: string | null): string | undefined {
  if (typeof value !== 'string') {
    return undefined;
  }
  const normalized = collapseWhitespace(value).replace(/\s+,/g, ',');
  return normalized.length ? normalized : undefined;
}

export function toValidMapAddress(value?: string | null): string | undefined {
  const normalized = normalizeMapAddressInput(value);
  if (!normalized) {
    return undefined;
  }
  return MAP_ADDRESS_REGEX.test(normalized) ? normalized : undefined;
}

export function isMapAddressValid(value?: string | null): boolean {
  return !!toValidMapAddress(value);
}

export function mapAddressValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const raw = control.value;
    if (raw === null || raw === undefined || raw === '') {
      return null;
    }
    if (typeof raw !== 'string') {
      return { mapAddress: true };
    }
    return isMapAddressValid(raw) ? null : { mapAddress: true };
  };
}
